import { createSelector } from 'reselect';

import getElectCertificatesSelector from './getElectCertificatesSelector';

export default createSelector([getElectCertificatesSelector], (certs) => certs?.length ?? 0);
